module.exports = "/components/components/attachments-6c6403.html";